
export default class QuarterlyReport {
  id: number;
  title?: string;
  year: number;
  quarter: string;
  url: string;
  imageUrl: string;

  constructor(entity: QuarterlyReport) {
    this.id = entity.id;
    this.title = entity.title;
    this.year = entity.year;
    this.quarter = entity.quarter;
    this.url = entity.url;
    this.imageUrl = entity.imageUrl;
  }
}



// WEBPACK FOOTER //
// ./src/entities/QuarterlyReport.tsx